const indexItems = [
  { title: '2026上半年塌房大盘点', count: '47篇', tag: '合集', icon: 'ri-folder-chart-line' },
  { title: '抖音头部网红档案', count: '32篇', tag: '档案', icon: 'ri-profile-line' },
  { title: '情感博主翻车合集', count: '28篇', tag: '分类', icon: 'ri-emotion-sad-line' },
  { title: '带货主播假货实录', count: '25篇', tag: '专题', icon: 'ri-shopping-bag-3-line' },
  { title: 'MCN机构黑幕揭秘', count: '21篇', tag: '深度', icon: 'ri-building-line' },
  { title: '美妆博主打假系列', count: '19篇', tag: '打假', icon: 'ri-magic-line' },
  { title: '税务风波全追踪', count: '16篇', tag: '追踪', icon: 'ri-money-cny-circle-line' },
  { title: '法律追责案例集', count: '14篇', tag: '法律', icon: 'ri-scales-3-line' },
  { title: '直播事故名场面', count: '12篇', tag: '回顾', icon: 'ri-live-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">吃瓜专题</h2>
            <p className="mt-2 text-sm text-foreground-500">按主题分类的网红黑料合集，方便你系统性地吃透每一个瓜</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {indexItems.map((item, idx) => (
              <div
                key={idx}
                className="group cursor-pointer flex items-center gap-4 p-4 rounded-xl bg-background-200/70 border border-background-300/40 hover:border-accent-500/30 transition-all duration-300"
              >
                <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-500/15 text-accent-500 transition-transform duration-300 group-hover:scale-110">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-accent-500 transition-colors duration-200 truncate">
                      {item.title}
                    </h3>
                    <span className="flex-shrink-0 text-xs px-1.5 py-0.5 rounded bg-accent-500/15 text-accent-500 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-400">{item.count}</p>
                </div>
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center text-foreground-400 group-hover:text-accent-500 transition-colors duration-200">
                  <i className="ri-arrow-right-s-line text-lg"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}